import React from 'react'
import styled from "styled-components";

const Boton = styled.button`
    background-color: ${({ theme }) => theme.danger || '#dc3545'};
    color: #FFF;
    border: none;
    transition: ease-in-out 200ms; 
    cursor: pointer;   
    display: inline-flex;
    padding: 0.15rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    justify-content: center;
    &:hover {
        background-color: ${({ theme }) => theme.dangerHover|| '#b20c1c'};
        border-color: ${({ theme }) => theme.dangerHover|| '#b20c1c'};
        color: #FFF;
    }
`;

export default function BotonDanger({ children, onClick, ancho, className, ...rest } ) {
    return <Boton
        {...rest}
        onClick={onClick}
        style={{width: ancho}}
    >
            {children}
    </Boton> 
}